import { Text } from "@dropbox/dig-components/typography";

export const EnterKey = () => {
  return <Text color="subtle">⏎</Text>;
};
